export function convertToInt(v: number | string): number {
  if (typeof v === "number") return v;

  return parseInt(v);
}
